import axios from "axios";
import config from "../config/config";
import { apiHelper } from "../utils/apiHelper";

const _endpoint = `/api/api-keys`;

export const apiKeysApi = {
  /**
   * @param {{ search?: string, page?: number, pageSize?: number }} [params]
   * @returns {Promise<{ keys: unknown[], total: number }>}
   */
  getApiKeys: (params = {}) => {
    const { search, page, pageSize } = params;
    return axios(`${_endpoint}`, {
      baseURL: config.apiURL,
      withCredentials: true,
      method: "get",
      params: {
        ...(search ? { search } : {}),
        ...(page != null ? { page } : {}),
        ...(pageSize != null ? { pageSize } : {}),
      },
    })
      .then((result) => {
        const body = result.data;
        if (body && Array.isArray(body.keys)) {
          return {
            keys: body.keys,
            total: typeof body.total === "number" ? body.total : body.keys.length,
          };
        }
        if (Array.isArray(body)) {
          return { keys: body, total: body.length };
        }
        return { keys: [], total: 0 };
      })
      .catch((err) => apiHelper.handleError(err));
  },
  createApiKey: (data) => {
    return axios(`${_endpoint}`, {
      baseURL: config.apiURL,
      withCredentials: true,
      method: "post",
      data,
    })
      .then((result) => result.data)
      .catch((err) => apiHelper.handleError(err));
  },
  deleteApiKey: (data) => {
    return axios(`${_endpoint}/${data.id}`, {
      baseURL: config.apiURL,
      withCredentials: true,
      method: "delete",
    })
      .then((result) => result.data)
      .catch((err) => apiHelper.handleError(err));
  },
};
